<template>
  <div class="body" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_CRED)">
      <div class="d-flex" v-if="!requestsDetails">
        <div class="col-md-3" >
            <searchRequests v-on:updateTable = "updateTable" v-on:SearchItems="GetFilter"></searchRequests>
        </div>
        <div class="col-md-9" >
            <tableRequests ref="tableRequestComponent" :key="tablereload" v-on:edit="edit"></tableRequests>
        </div>
      </div>
      <RequestDetails :dataDetails="selectedSolicitacao" v-if="requestsDetails" ></RequestDetails>
  </div>
</template>

<script>

import requests from '@/views/private/realestate/requests/requests'
export default requests

</script>

<style scoped>
.body{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/requests.vue